// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Data types enum.
 */
export enum DataTypeEnum {
  Unspecified = 0,
  Int8 = 1,
  Int16 = 2,
  Int32 = 3,
  Int64 = 4,
  Float32 = 5,
  Float64 = 6,
  Decimal = 7,
  Date = 8,
  Time = 9,
  Timestamp = 10,
  Binary = 11,
  Utf8 = 12
}
